import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableRaportWakel from "./ScroollTableRaportWakel";
import NavbarOfRaportWakel from "./NavbarOfRaportWakel";
import FooterOfRaportWakel from "./FooterOfRaportWakel";
import Time from "react-time-format";
import { ProductConsumer } from "../../../Context/AddProWakel";

const AllWakelRaport = () => {
  var today = new Date();
  var kat =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  return (
    <ProductConsumer>
      {(value) => {
        const {
          RW_zh_barez,
          RW_nawibrez,
          RW_mob,
          RW_from,
          RW_to,
          exportToCSV,
          RW_dataWakelRaport
        } = value;

        return (
          <div>
            <Navbar />
            <div className="row" style={{ backgroundColor: "#2C3539" }}>
              <div
                className="col-lg-10 col-12"
                style={{ marginTop: "60px" }}
              >
                <div className="row">
                  <div className="col-3">
                    <div className="row">
                      {/* <div className="col-3"></div> */}
                      <div className="col-6  tc form-inline">
                        <p
                          className="font-weight-bold bg-white  f4"
                          style={{ color: "#000" }}
                        >
                          <Time format="YYYY-MM-DD" />
                        </p>
                        <span style={{ color: "#2C3539" }}>:</span>
                        <p
                          className="font-weight-bold bg-white  f4"
                          style={{ color: "#000" }}
                        >
                          {RW_to}
                        </p>
                      </div>
                      <div className="col-6 form-inline">
                        <label className="text-warning font-weight-bold f4">
                          :بۆ بەرواری{" "}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="row">
                      <div className="col-6 tc form-inline">
                        <p
                          className="font-weight-bold bg-white f4"
                          style={{ color: "#000" }}
                        >
                          <Time format="YYYY-MM-DD" />
                        </p>
                        <span style={{ color: "#2C3539" }}>:</span>
                        <p
                          className="font-weight-bold bg-white f4"
                          style={{ color: "#000" }}
                        >
                          {RW_from}
                        </p>
                      </div>
                      <div className="col-6 form-inline">
                        <label className="text-warning font-weight-bold f4">
                          : لە بەرواری{" "}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-6" style={{ paddingTop: "25px" }}>
                    <div className="row">
                      <div className="col-2">
                        <h4 className="fk text-black font-weight-bold f4 bg-white tc py-2">
                          {RW_zh_barez}
                        </h4>
                      </div>
                      <div className="col-4">
                        <h4 className="fk text-black font-weight-bold f4 bg-white tc py-2">
                          {RW_mob}
                        </h4>
                      </div>
                      <div className="col-4">
                        <h4 className="fk text-black font-weight-bold f4 bg-white tc py-2">
                          {RW_nawibrez}
                        </h4>
                      </div>
                      <div className="col-2">
                        <span
                          className={`font-weight-bold  pointer text-warning`}
                          style={{ paddingLeft: "80px" }}
                        >
                          <button
                            className="btn btn-warning"
                            onClick={(e) =>
                              exportToCSV(RW_dataWakelRaport, `${kat}-وەکیل`)
                            }
                          >
                            دابەزاندن
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-10 col-11 col-sm-12">
                <ScroollTableRaportWakel />
              </div>
              <div className="col-lg-2 col-1 col-sm-12">
                <NavbarOfRaportWakel />
              </div>
            </div>

            <div style={{ backgroundColor: "#2C3539" }}>
              <FooterOfRaportWakel />
            </div>
          </div>
        );
      }}
    </ProductConsumer>
  );
};
export default AllWakelRaport;
